import { ErpPartnersAgreements } from "src/entities/erpPartnersAgreements/ui/ErpPartnersAgreements";

export const ErpPartnersAgreementsPage = () => {
  return <ErpPartnersAgreements />;
};
